<template>
    <div>
        <form id="payment-form">
            <div class="field is-horizontal" style="justify-content: end;">
<!--                <div class="field-label">-->
<!--                    <label class="label" for="card-element">Credit or debit card</label>-->
<!--                </div>-->
                <div class="field stripe-card">
                    <label>Card number</label> <div id="cardNumber-element" class="error"/>
                    <div
                        class="help is-danger"
                        id="cardNumber-errors"
                    />
                    <label>Expiration</label> <div id="cardExpiry-element"/>
                    <div
                        class="help is-danger"
                        id="cardExpiry-errors"
                    />
                    <label>CVC</label> <div id="cardCvc-element"/>
                    <div
                        class="help is-danger"
                        id="cardCvc-errors"
                    />
                    <label class="not-element">Billing ZIP</label> <div><input v-model="zip" placeholder="04609" data-cy="payment-zip"></div>
                    <div
                        class="help is-danger"
                        v-show="zipErrors"
                        v-text="zipErrors"
                        style="margin-top: 0;"
                    />
                    <p
                        class="help is-danger"
                        id="card-errors"
                    />
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label"/>
                <div class="field">
                    <button
                        id="getToken"
                        v-bind:disabled="!okToPay || !payButtonEnabled"
                        v-on:click.prevent="getToken"
                        v-text="buttonLabel"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import upperFirst from 'lodash/upperFirst';
    import axios from 'axios';

    export default {
        props: {
            amount: {
                type: Number,
                required: true
            },
            okToPay: Boolean,
            buttonLabel: {
                type: String,
                default: 'Pay now',
            },
        },
        data: function() {
            return {
                stripe: null,
                card: {
                    number: {
                        element: null,
                        valid: false
                    },
                    expiry: {
                        element: null,
                        valid: false
                    },
                    cvc: {
                        element: null,
                        valid: false
                    }
                },
                zip: null,
                readyToPay: true,
            }
        },
        computed: {
            payButtonEnabled() {
                return this.okToPay
                    && this.readyToPay
                    && this.card.number.valid
                    && this.card.expiry.valid
                    && this.card.cvc.valid
                    && String(this.zip).trim().length >= 5
                ;
            },
            zipErrors() {
                // if (/^\d{5}(-\d{4})?$/.test(this.zip)) {
                //     return '';
                // }
                if (this.zip === null || this.zip.trim()) {
                    return '';
                }
                return 'Postal code is required.';
            },
        },
        methods: {
            getToken: function() {
                let vue = this;
                vue.readyToPay = false;
                vue.stripe.createToken(vue.card.number.element, {address_zip: vue.zip}).then(function(result) {
                    if (result.error) {
                        document.getElementById('cardNumber-errors').textContent = result.error.message;
                        axios.post('/api/logs', {message: 'PaymentForm.getToken error: '.result.error.message});
                    } else {
                        axios.post('/api/logs', {message: 'PaymentForm.getToken success'});
                        vue.$emit('gotToken', result.token.id);
                        for (let prop in vue.card) {
                            vue.card[prop].element.clear();
                        }
                    }
                });
            },
        },
        created: function() {
            let vue = this;
            let stripeScriptId = 'stripe-script';
            
            if (!document.getElementById(stripeScriptId)) {
                let script = document.createElement('script');
                script.setAttribute('src', 'https://js.stripe.com/v3/');
                script.setAttribute('id', stripeScriptId);
                document.head.appendChild(script);
            }
            let stripeInterval = window.setInterval(function() {
                try {
                    vue.stripe = Stripe(cinerama.config.stripe_key);
                    let elements = vue.stripe.elements();
                    ['number', 'expiry', 'cvc'].forEach(function(prop) {
                        vue.card[prop].element = elements.create('card' + upperFirst(prop));
                        vue.card[prop].element.mount('#card' + upperFirst(prop) + '-element');
                        vue.card[prop].element.addEventListener('change', function(event) {
                            vue.readyToPay = !event.empty;
                            let errorElement = document.getElementById('card' + upperFirst(prop) + '-errors');
                            if (event.error) {
                                errorElement.textContent = event.error.message;
                                vue.card[prop].valid = false;
                            } else {
                                errorElement.textContent = '';
                                vue.card[prop].valid = true;
                            }
                        });
                    });
                    window.clearInterval(stripeInterval);
                } catch (err) {
                    // noop
                }
            }, 250);
        }
    }
</script>

<style lang="scss">
    .stripe-card {
        & > div {
            margin-top: 5px;
            border: 1px solid #4a4a4a;
            color: #4a4a4a;
            padding: 2px;
            display: inline-block;
            width: 12em;
        }

        input {
            border: none;
            font-size: 14px;
            font-family: sans-serif;
            display: block;
        }

        & > div.is-danger {
            border: none;
            padding: 0;
            width: 100%;
            display: block;
            margin: -5px 0 0 0;
            text-align: right;

        }

        & > label {
            vertical-align: super;
            display: inline-block;
            width: 7.5em;
            text-align: right;
            margin-right: 8px;

            &.not-element {
                vertical-align: baseline;
            }

            @media(max-width: 349px) {
                width: 100%;
                text-align: left;
            }
        }
    }
</style>